import { render } from "./Testimonials.vue?vue&type=template&id=55bd339b&scoped=true"
import script from "./Testimonials.vue?vue&type=script&lang=js"
export * from "./Testimonials.vue?vue&type=script&lang=js"

import "./Testimonials.vue?vue&type=style&index=0&id=55bd339b&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-55bd339b"

export default script